import React, { Component } from 'react';
import { Modal, Tabs, Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import logo from '../images/XNS.svg';
import { Api } from '../lib/api';
import { createUser } from '../lib/signUpUtils';

import './styles.scss';
const { TabPane } = Tabs;
class SignIn extends Component {
    state = {
        disableRegisterion: false,
        defaultTab: '2'
    };

    componentDidMount() {
        this.getCount();
    }
    async getCount() {
        await Api.getCount().then(async (result) => {
            if (result >= 2) {
                this.setState({ disableRegisterion: true, defaultTab: '1' });
            }
        });
    }
    info() {
        alert(
            'Please, contact Santec Canada if you forgot your password.\n Email: support.inst@santec.com \n Phone Number: +1 (613) 599-1000 '
        );
    }
    onFinish = async (values) => {
        await Api.login(values).then(async (result) => {
            if (result !== false) {
                let payload = await this.parseJwt(result);

                localStorage.setItem('user', result);
                localStorage.setItem('username', payload.username);
                localStorage.setItem('role', payload.role);

                window.location.pathname = '/';
            } else {
                alert("Your username and password don't match, please try again ");
            }
        });
    };
    signUp = async (values) => {
        await createUser(values.username, values.password, false, () => {
            this.setState({ defaultTab: '1' });
        });
    };
    async parseJwt(token) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = await decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
        );

        return JSON.parse(jsonPayload);
    }
    render() {
        return (
            <Modal
                open={!localStorage.getItem('user')}
                onOk={this.props.closeSignIn}
                onCancel={this.props.closeSignIn}
                closable={false}
                footer={null}
            >
                <Tabs
                    onChange={() => {
                        if (!this.state.disableRegisterion) {
                            this.setState({ defaultTab: this.state.defaultTab === '2' ? '1' : '2' });
                        }
                    }}
                    activeKey={this.state.defaultTab && this.state.defaultTab}
                    centered
                >
                    <TabPane tab="LOG IN" key="1">
                        <div className="xn1-logo">
                            <img src={logo} alt="XNS" />
                        </div>
                        <Form
                            name="normal_login"
                            className="login-form"
                            initialValues={{ remember: true }}
                            onFinish={this.onFinish}
                        >
                            <Form.Item name="username" rules={[{ required: true, message: 'Please input your Username!' }]}>
                                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
                            </Form.Item>
                            <Form.Item name="password" rules={[{ required: true, message: 'Please input your Password!' }]}>
                                <Input
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    type="password"
                                    placeholder="Password"
                                />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="login-form-button">
                                    Log in
                                </Button>
                            </Form.Item>
                            <Form.Item>
                                <p className="login-form-forgot" onClick={this.info}>
                                    Forgot password
                                </p>
                            </Form.Item>
                        </Form>{' '}
                    </TabPane>
                    <TabPane tab="REGISTER" disabled={this.state.disableRegisterion} key="2">
                        <div className="xn1-logo">
                            <img className="grey" src={logo} alt="XN1" />
                        </div>
                        <Form name="register" onFinish={this.signUp} className="login-form">
                            <Form.Item
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your username'
                                    }
                                ]}
                            >
                                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
                            </Form.Item>

                            <Form.Item
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your password!'
                                    }
                                ]}
                                hasFeedback
                            >
                                <Input.Password
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    placeholder="Password"
                                />
                            </Form.Item>

                            <Form.Item
                                name="confirm"
                                dependencies={['password']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please confirm your password!'
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(
                                                new Error('The two passwords that you entered do not match!')
                                            );
                                        }
                                    })
                                ]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    placeholder="Password"
                                />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="login-form-button">
                                    Register
                                </Button>
                            </Form.Item>
                        </Form>
                    </TabPane>
                </Tabs>
            </Modal>
        );
    }
}

export default SignIn;
